import { useDispatch } from 'react-redux';
import { expand } from '@rsos/reduxDataStore/src/features/eventPane/eventPaneSlice';
import { setSelectedTab } from '@rsos/reduxDataStore/src/features/eventPane/eventPaneSlice';
import { CHAT_TAB } from '@rsos/reduxDataStore/src/features/eventPane/eventPaneTabs';
import { NotificationPill } from './HeaderNotifications.styles';
import { useChatNotifications } from './useChatNotifications';

interface Props {
  callerID: string;
}

export function ChatNotifications({ callerID }: Props) {
  const { numberOfMessages } = useChatNotifications(callerID);
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(setSelectedTab(CHAT_TAB));
    dispatch(expand());
  };

  if (numberOfMessages === 0) {
    return null;
  }

  const messageText = numberOfMessages > 1 ? 'messages' : 'message';

  return (
    <NotificationPill onClick={handleClick}>
      {numberOfMessages} new {messageText}
    </NotificationPill>
  );
}
